import { Component } from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { TranslocoDirective } from "@jsverse/transloco";
import { FormlyFieldConfig, FormlyForm } from "@ngx-formly/core";
import { ButtonModule } from "primeng/button";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { FluidModule } from "primeng/fluid";
import { ServiceManageDialogResult } from "./service-manage-dialog.types";
import { ExtraServiceManageDialogDefinition } from "../../../../domain/extra-service";
import { FormService } from "../../../../services/form.service";
import { primeNgPageModules } from "../../../../shared/modules/prime-ng-common.module";
import { FormlyFieldConfigTranslatable } from "../../../../shared/types/form";

@Component({
  templateUrl: "./service-manage.dialog.html",
  imports: [...primeNgPageModules, ReactiveFormsModule, FormlyForm, ButtonModule, FluidModule, TranslocoDirective],
})
export class ServiceManageDialog {
  public readonly form = new FormGroup({});
  public readonly definition: ExtraServiceManageDialogDefinition;
  public readonly model: Record<string, unknown>;
  public readonly fields: FormlyFieldConfig[];

  constructor(
    private readonly formService: FormService,
    private readonly config: DynamicDialogConfig<ExtraServiceManageDialogDefinition>,
    public readonly ref: DynamicDialogRef<ServiceManageDialogResult>,
  ) {
    if (!this.config.data) {
      throw new Error("Service manage dialog configuration not found");
    }

    this.definition = this.config.data;
    this.model = this.createInitialModel();
    this.fields = [
      {
        fieldGroupClassName: "flex flex-col gap-5", // Managing the gap between the fields
        fieldGroup: this.formService.prepareFormFields(this.definition.fields, this.definition.context),
      },
    ];
  }

  public close(): void {
    this.ref.close();
  }

  public submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.ref.close({
      submitted: true,
      value: this.form.getRawValue() as Record<string, unknown>,
    });
  }

  private createInitialModel(): Record<string, unknown> {
    const model = { ...(this.definition.initialModel ?? {}) };

    for (const key of this.collectCalendarFieldKeys(this.definition.fields)) {
      const value = model[key];

      if (typeof value === "string") {
        model[key] = new Date(value);
      }
    }

    return model;
  }

  private collectCalendarFieldKeys(fields: FormlyFieldConfigTranslatable[]): string[] {
    const keys: string[] = [];

    for (const field of fields) {
      if (field.fieldGroup) {
        keys.push(...this.collectCalendarFieldKeys(field.fieldGroup));
      } else if (field.type === "calendar" && typeof field.key === "string") {
        keys.push(field.key);
      }
    }

    return keys;
  }
}
